import React, { FC, useContext } from 'react';

import { FileManagerContext } from '../context';
import { IBaseComponent } from 'components/base/types';

export const FileManagerContainer: FC<IBaseComponent> = (
  { children },
) => {
  const { activeView } = useContext(FileManagerContext);

  if (activeView === 'detail-view') {
    return (
      <div className="f-file-manager-container"><div>{children}</div></div>
    );
  }
  return (<div className="f-file-manager-container">{children}</div>);
};
